import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  allInterpreters: [],
  interpretersWithAppointments: [],
  invitedInterpreters: [],
  inviteInterpreters: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  dynamicFields: [

  ],
  analytics: [],
  appointment: []
}

export const inviteInterpretersSlice = createSlice({
  name: 'inviteInterpreters',
  initialState: initialState,
  reducers: {
    setInviteInterpreter: (state, { payload }) => {
      state.inviteInterpreters = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
    },
    setInviteInterpreters: (state, { payload }) => {
      state.inviteInterpreters = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
    },
    setAllInterpreters: (state, { payload }) => {
      state.allInterpreters = payload?.data;

    },
    setAppointment: (state, { payload }) => {
      state.appointment = payload?.data?.invites;
    },
    setInterpretersWithAppointments: (state, { payload }) => {
      state.interpretersWithAppointments = payload?.data;
    },
    setInvitedInterpreters: (state, { payload }) => {
      state.invitedInterpreters = payload?.data;
    },
    setDynamicFields: (state, { payload }) => {
      state.dynamicFields = payload?.data;
    },

    setMoreInviteInterpreters: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
    },
    removeInviteInterpreter: (state, { payload }) => {
      state.error = payload
    },
    clearAllInviteInterpreter: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const addInviteInterpreter = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addInviteInterpreter(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInviteInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const updateInviteInterpreter = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateInviteInterpreter(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInviteInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeInviteInterpreter = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeInviteInterpreter(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInviteInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchInviteInterpreters = (page, params, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchInviteInterpreters(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setInviteInterpreters(result.data.data));
      } else {
        dispatch(setInviteInterpreters(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}
export const fetchAppointmentsInterpreters = (id) => async (dispatch) => {
  const apiService = new Api();
  try {

    const result = await Api.fetchAppointmentsInterpreters(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setAllInterpreters(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
}
export const fetchInterpretersWithAppointments = (id) => async (dispatch) => {
  const apiService = new Api();
  try {

    const result = await Api.fetchInterpretersWithAppointments(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setInterpretersWithAppointments(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
}
export const fetchInvitedInterpreters = (id) => async (dispatch) => {
  const apiService = new Api();
  try {

    const result = await Api.fetchInvitedInterpreters(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setInvitedInterpreters(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
}

export const removeInvitedInterpreters = (ids, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeInvitedInterpreters(itemId, ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
};
export const addInviteInterpreters = (ids, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.inviteInterpreters(itemId, ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
      dispatch(setLoader(false))
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
      dispatch(setLoader(false))
    }
  } catch (error) {
    console.log(error)
    callback(false)
    dispatch(setLoader(false))

  }
}
export const fetchAppointmentView = (id) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const result = await Api.fetchClientAppointmentView(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setAppointment(result?.data))
      dispatch(setLoader(false))
    } else if (result?.status == 422) {
      dispatch(setError(result.data))
      dispatch(setLoader(false))
      // callback&&callback(false, result?.data?.message)
    }
  } catch (error) {
    console.log("error", error)
    dispatch(setLoader(false))
    // callback&&callback(false, error?.data?.message)
  }

}

export const fetchInterpreterRates = async(appt_id, terp_id, callback) => {
  try {
    const result = await Api.fetchInterpreterRates(appt_id, terp_id)
    if (result.status >= 200 && result.status < 300) {
      callback && callback(true, result?.data?.message, result?.data?.data)
    } else if (result?.status == 422) {
      callback && callback(false, result?.data?.message,)
    }
    else {
      callback && callback(false, result?.data?.message)
    }
  } catch (error) {
    console.log("error", error)
    callback && callback(false, error?.data?.message)
  }

}
export const submitApptCustomWorkOrder = async(data, callback) => {
  try {
    const result = await Api.submitApptCustomWorkOrder(data)
    if (result.status >= 200 && result.status < 300) {
      callback && callback(true, result?.data?.message, result?.data?.data)
    } else if (result?.status == 422) {
      callback && callback(false, result?.data?.message,)
    }
    else {
      callback && callback(false, result?.data?.message)
    }
  } catch (error) {
    console.log("error", error)
    callback && callback(false, error?.data?.message)
  }

}

export const { setInviteInterpreter, setInterpretersWithAppointments, setInviteInterpreters, setAllInterpreters, clearAllInviteInterpreter, setLoader, setError, setMoreInviteInterpreters, setDynamicFields, setAppointment, setInvitedInterpreters } = inviteInterpretersSlice.actions


export default inviteInterpretersSlice.reducer
export const inviteInterpretersSelector = state => state.inviteInterpreters


